/* Fixes the main nav bar (.header-content) to the top of the viewport once
   scrolled past the announcement bar, without fixing the announcement bar
   itself. A spacer element (.header-content-spacer, added right after
   </header> in sections/header.liquid) is given the bar's real height only
   while it's fixed, so removing it from normal flow doesn't jump the page
   content below it. Independent of the theme's existing "Enable sticky
   header" (dock_nav) setting/JS, which only docks the search/account/cart
   icons on desktop - this fixes the actual nav links and logo too. */
(function () {
  var header = document.querySelector('.site-header .header-content');
  var spacer = document.querySelector('.header-content-spacer');
  if (!header || !spacer) return;

  var announcementBar = document.querySelector('.announcement-bar');
  var fixedClass = 'header-content--fixed';
  var ticking = false;

  function threshold() {
    return announcementBar ? announcementBar.offsetHeight : 0;
  }

  /* Publishes the header's real fixed height as a CSS variable so other
     elements can offset themselves below it - specifically the product
     page's sticky info column (styles.css: ".product-detail__detail.
     sticky-element", "position: sticky; top: 30px") and sticky image
     gallery (".product-layout-grid__images .sticky-element", same
     30px), which don't know about this fixed header at all. Once this
     header is fixed, a flat 30px offset isn't enough to clear it, so the
     column's own top edge - and the vendor name sitting right at the
     top of it - ends up rendered underneath the fixed bar. custom-
     theme-fixes.css reads this variable via calc() with a 0px fallback,
     so nothing changes while the header isn't fixed or before this
     script runs. */
  function setFixedHeaderHeight(px) {
    document.documentElement.style.setProperty('--fixed-header-height', px + 'px');
  }

  function update() {
    ticking = false;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var isFixed = header.classList.contains(fixedClass);

    if (!isFixed && scrollY >= threshold()) {
      spacer.style.height = header.offsetHeight + 'px';
      header.classList.add(fixedClass);
      setFixedHeaderHeight(header.offsetHeight);
    } else if (isFixed && scrollY < threshold()) {
      header.classList.remove(fixedClass);
      spacer.style.height = '0px';
      setFixedHeaderHeight(0);
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    if (header.classList.contains(fixedClass)) {
      spacer.style.height = header.offsetHeight + 'px';
      setFixedHeaderHeight(header.offsetHeight);
    }
  });

  update();
})();
